import React from 'react';
import { hospitalConfig } from '@/data/hospitalConfig';

interface MedicalDisclaimerProps {
  compact?: boolean;
}

export default function MedicalDisclaimer({ compact = false }: MedicalDisclaimerProps) {
  if (compact) {
    return (
      <p className="disclaimer-text text-center px-4">
        🔒 {hospitalConfig.disclaimer}
      </p>
    );
  }

  return (
    <div
      className="border border-border rounded-xl p-4 bg-muted"
      role="note"
      aria-label="Medical disclaimer"
    >
      <p className="disclaimer-text">
        <span className="font-semibold text-muted-foreground">Medical Notice: </span>
        {hospitalConfig.disclaimer}
      </p>
    </div>
  );
}